import employeeGroupsService from '@/api/employeegroups'
import { EMPLOYEE_GROUPS } from '../types'
import strings from '@/strings'
import utils from '@/utils/utils.js'
import filedownloader from '@/utils/filedownloader.js'

export default {
  namespaced: true,
  state: {
    employees: [],
    groups: [],
    groupId: null,
    groupName: '',
    groupImportCode: '',
    groupTeamManagers: [],
    groupDeskGroups: [],
    groupCharteredBuses: [],
    groupParkings: [],
    groupLockers: [],
    groupRooms: [],
    groupEmployees: [],
    availableDeskGroups: [],
    availableCharteredBuses: [],
    availableParkings: [],
    availableLockers: [],
    availableRooms: [],
    fileStatus: strings.uploadStatus.waiting,
    fileId: '',
    isDownloadingFile: false,
    slotsLoadingStatus: 'STATUS_INITIAL',
    groupInfo: {
      employeesCount: 0
    },
    toRemoveFromEmployeeGroup: [],
    loadingEmployees: false,
    employeesInfo: {
      employeesTotalNumber: 0
    },
    employeesOutsideGroup: []
  },
  getters: {
    groupName(state) {
      return state.groupName
    },
    groupImportCode(state) {
      return state.groupImportCode
    },
    groupDeskGroups(state) {
      return state.groupDeskGroups
    },
    groupCharteredBuses(state) {
      return state.groupCharteredBuses
    },
    groupParkings(state) {
      return state.groupParkings
    },
    groupLockers(state) {
      return state.groupLockers
    },
    groupRooms(state) {
      return state.groupRooms
    },
    groupEmployees(state) {
      return state.groupEmployees
    },
    selectedAll(state) {
      return state.groups.every(group => group.selected === true)
    }
  },
  mutations: {
    [EMPLOYEE_GROUPS.SET_GROUPS](state, groups) {
      state.groups = groups
    },
    [EMPLOYEE_GROUPS.SET_GROUP_ID](state, groupId) {
      state.groupId = groupId
    },
    [EMPLOYEE_GROUPS.SET_GROUP_NAME](state, groupName) {
      state.groupName = groupName
    },
    [EMPLOYEE_GROUPS.SET_GROUP_IMPORTCODE](state, importCode) {
      state.groupImportCode = importCode
    },
    [EMPLOYEE_GROUPS.SET_GROUP_TEAM_MANAGERS](state, teamManagers) {
      state.groupTeamManagers = teamManagers
    },
    [EMPLOYEE_GROUPS.SET_GROUP_DESKGROUPS](state, deskGroups) {
      state.groupDeskGroups = deskGroups
    },
    [EMPLOYEE_GROUPS.SET_GROUP_CHARTEREDBUSES](state, charteredBuses) {
      state.groupCharteredBuses = charteredBuses
    },
    [EMPLOYEE_GROUPS.SET_GROUP_PARKINGS](state, parkings) {
      state.groupParkings = parkings
    },
    [EMPLOYEE_GROUPS.SET_GROUP_LOCKERS](state, lockers) {
      state.groupLockers = lockers
    },
    [EMPLOYEE_GROUPS.SET_GROUP_ROOMS](state, rooms) {
      state.groupRooms = rooms
    },
    [EMPLOYEE_GROUPS.SET_GROUP_EMPLOYEES](state, groupEmployees) {
      state.groupEmployees = groupEmployees
    },
    [EMPLOYEE_GROUPS.ADD_GROUP_EMPLOYEES](state, groupEmployees) {
      state.groupEmployees = state.groupEmployees.concat(groupEmployees)
    },
    [EMPLOYEE_GROUPS.SET_EMPLOYEES_OUTSIDE_GROUP](state, employeesOutsideGroup) {
      state.employeesOutsideGroup = employeesOutsideGroup
    },
    [EMPLOYEE_GROUPS.SELECT_EMPLOYEES](state, employees) {
      state.employees.push(employees)
    },
    [EMPLOYEE_GROUPS.SET_EMPLOYEES](state, employees) {
      state.employees = employees
    },
    [EMPLOYEE_GROUPS.REMOVE_EMPLOYEES](state, index) {
      state.employees.splice(index, 1)
    },
    [EMPLOYEE_GROUPS.SET_AVAILABLE_GROUPS](state, groups) {
      state.availableDeskGroups = groups
    },
    [EMPLOYEE_GROUPS.SET_AVAILABLE_CHARTERED_BUSES](state, availableCharteredBuses) {
      state.availableCharteredBuses = availableCharteredBuses
    },
    [EMPLOYEE_GROUPS.SET_AVAILABLE_PARKINGS](state, availableParkings) {
      state.availableParkings = availableParkings
    },
    [EMPLOYEE_GROUPS.SET_AVAILABLE_LOCKERS](state, availableLockers) {
      state.availableLockers = availableLockers
    },
    [EMPLOYEE_GROUPS.SET_AVAILABLE_ROOMS](state, availableRooms) {
      state.availableRooms = availableRooms
    },
    [EMPLOYEE_GROUPS.SET_FILE_STATUS](state, status) {
      state.fileStatus = status
    },
    [EMPLOYEE_GROUPS.SET_FILE_ID](state, fileId) {
      state.fileId = fileId
    },
    [EMPLOYEE_GROUPS.SELECT_TEAM_MANAGER](state, item) {
      state.groupTeamManagers.push(item)
    },
    [EMPLOYEE_GROUPS.REMOVE_TEAM_MANAGER](state, index) {
      state.groupTeamManagers.splice(index, 1)
    },
    [EMPLOYEE_GROUPS.SET_IS_DOWNLOADING_FILE](state, value) {
      state.isDownloadingFile = value
    },
    [EMPLOYEE_GROUPS.SELECT_GROUP](state, id) {
      let index = state.groups.findIndex(group => group.id === id)
      state.groups[index].selected = !state.groups[index].selected
    },
    [EMPLOYEE_GROUPS.SELECT_ALL_GROUP](state, selectedAll) {
      let finalState = !selectedAll
      state.groups.forEach(group => {
        group.selected = finalState
      })
    },
    [EMPLOYEE_GROUPS.SET_LOADING_STATUS](state, slotsLoadingStatus) {
      state.slotsLoadingStatus = slotsLoadingStatus
    },
    [EMPLOYEE_GROUPS.SET_GROUPS_INFO](state, groupInfo) {
      state.groupInfo = groupInfo
    },
    [EMPLOYEE_GROUPS.SET_EMPLOYEES_INFO](state, employeesInfo) {
      state.employeesInfo = employeesInfo
    },
    [EMPLOYEE_GROUPS.SET_REMOVE_LIST](state, toRemoveFromEmployeeGroup) {
      state.toRemoveFromEmployeeGroup = toRemoveFromEmployeeGroup
    },
    [EMPLOYEE_GROUPS.REMOVE_FROM_EMPLOYEE_GROUP](state, employeeToRemove) {
      state.toRemoveFromEmployeeGroup.push(employeeToRemove)
      state.groupEmployees = state.groupEmployees.filter((groupEmployee) => groupEmployee.id !== employeeToRemove)
    },
    [EMPLOYEE_GROUPS.SET_LOADING_EMPLOYEES](state, loadingEmployees) {
      state.loadingEmployees = loadingEmployees
    },
  },
  actions: {
    async getEmployeeGroups({ dispatch, commit }) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        let response = await employeeGroupsService.getEmployeeGroups()
        response.data.forEach((item) => {
          item.selected = false
        })
        commit(EMPLOYEE_GROUPS.SET_GROUPS, response.data)
        dispatch('resetGroup')
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async getEmployeeGroup({ dispatch }, id) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        let response = await employeeGroupsService.getEmployeeGroup(id)
        let teamManagers = response.data.teamManagers ? response.data.teamManagers.map(managers => ({ email: managers.email })) : []
        await Promise.all([
          dispatch('setGroupId', response.data.id),
          dispatch('setGroupName', response.data.name),
          dispatch('setImportCode', response.data.importCode),
          dispatch('setTeamManagers', teamManagers),
          dispatch('setDeskGroups', response.data.deskGroups),
          dispatch('setCharteredBuses', response.data.charteredBuses),
          dispatch('setParkings', response.data.parkings),
          dispatch('setLockers', response.data.lockers),
          dispatch('setRooms', response.data.rooms)
        ])
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async getEmployeesFromGroup({ commit, state }, obj) {
      commit(EMPLOYEE_GROUPS.SET_LOADING_EMPLOYEES, true)
      if (obj.pageNumber === 1) {
        commit(EMPLOYEE_GROUPS.SET_LOADING_STATUS, 'STATUS_INITIAL')
        commit(EMPLOYEE_GROUPS.SET_GROUP_EMPLOYEES, [])
      }
      let response = await employeeGroupsService.getEmployeesFromGroup(obj)
      let employees = response.data

      employees = employees.filter(employee => !state.toRemoveFromEmployeeGroup.includes(employee.id));

      commit(EMPLOYEE_GROUPS.ADD_GROUP_EMPLOYEES, employees)
      commit(EMPLOYEE_GROUPS.SET_LOADING_EMPLOYEES, false)
      if (response.data.length < strings.colabAddedLimit) {
        commit(EMPLOYEE_GROUPS.SET_LOADING_STATUS, 'STATUS_END')
      } else {
        commit(EMPLOYEE_GROUPS.SET_LOADING_STATUS, 'STATUS_SUCCESS')
      }
    },
    async getEmployeesOutsideGroup({ commit, state }, obj) {
      commit(EMPLOYEE_GROUPS.SET_EMPLOYEES_OUTSIDE_GROUP, [])
      let response = await employeeGroupsService.getEmployeesOutsideGroup(obj)
      let employees = response.data

      employees = employees.filter(employee => !state.toRemoveFromEmployeeGroup.includes(employee.id));

      commit(EMPLOYEE_GROUPS.SET_EMPLOYEES_OUTSIDE_GROUP, employees)
    },
    async getGroupInfo({ dispatch, commit }, groupId) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        let response = await employeeGroupsService.getGroupInfo(groupId)
        commit(EMPLOYEE_GROUPS.SET_GROUPS_INFO, response.data)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async getEmployeesInfo({ commit }) {
      try {
        let response = await employeeGroupsService.getEmployeesInfo()
        commit(EMPLOYEE_GROUPS.SET_EMPLOYEES_INFO, response.data)
      } catch (error) {
        commit(EMPLOYEE_GROUPS.SET_EMPLOYEES_INFO, { employeesTotalNumber: 0 })
      }
    },
    async saveGroup({ dispatch, state }, obj) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        let group = {
          id: state.groupId,
          name: state.groupName,
          importCode: state.groupImportCode,
          teamManagers: state.groupTeamManagers.map(manager => manager.email),
          deskGroups: state.groupDeskGroups.map(item => item.id),
          charteredBuses: state.groupCharteredBuses.map(item => item.id),
          parkings: state.groupParkings.map(item => item.id),
          lockers: state.groupLockers.map(item => item.id),
          rooms: state.groupRooms.map(item => item.id),
          cancelFutureBookings: obj.cancelFutureBookings,
          addAllEmployees: obj.allEmployees
        }
        await employeeGroupsService.saveGroup(group)
        dispatch('Global/showMessage', state.groupId ? 'editGroupSuccessfully' : 'addGroupSuccessfully', { root: true })
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async deleteGroup({ dispatch }, params) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        await employeeGroupsService.deleteGroup(params.groupId, params.cancelFutureBookings)
        await dispatch('getEmployeeGroups')
        dispatch('Global/showMessage', 'removeGroupSuccessfully', { root: true })
      } catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    selectEmployee({ commit, }, item) {
      let owner = item.email ? { email: item.email, name: item.name, id: item.id } : { email: item }
      commit(EMPLOYEE_GROUPS.SELECT_EMPLOYEES, owner)
    },
    removeEmployee({ commit }, index) {
      commit(EMPLOYEE_GROUPS.REMOVE_EMPLOYEES, index)
    },
    async downloadEmployeeGroupsTemplate({ dispatch }) {
      try {
        let response = await employeeGroupsService.getEmployeeGroupsTempleteFile()
        let contentType = response.headers['content-type']
        let blob = new Blob([response.data], { type: contentType })
        utils.handleDownload(blob, 'template_employee_groups.xlsx')
      } catch (e) {
        dispatch('Global/showMessage', 'errorDefault', { root: true })
      }
    },
    async saveEmployeesIntoGroup({ dispatch, state }, obj) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        const employeesToSave = {
          employeesToAdd: state.employees.map(employee => employee.id),
          employeesToRemove: state.toRemoveFromEmployeeGroup,
          cancelFutureBookings: obj.cancelFutureBookings
        }
        await employeeGroupsService.saveEmployeesIntoGroup(obj.groupId, employeesToSave)
        dispatch('Global/showMessage', obj.groupId ? 'editGroupSuccessfully' : 'addGroupSuccessfully', { root: true })
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async downloadEmployeeGroupsFile({ dispatch, state }) {
      let selectedIds = state.groups.reduce((filtered, group) => {
        if (group.selected) {
          filtered.push(group.id)
        }
        return filtered
      }, [])

      await filedownloader.downloadFile(
        employeeGroupsService.getEmployeeGroupsFile.bind(employeeGroupsService),
        'employee_groups.xlsx',
        { selectedIds },
        dispatch
      )
    },
    async saveFile({ dispatch }, params) {
      dispatch('setFileStatus', strings.uploadStatus.uploading)
      try {
        await employeeGroupsService.importEmployeeGroupsFile(params.file, params.cancelFutureBookings)
        dispatch('setFileStatus', strings.uploadStatus.success)
      } catch (error) {
        dispatch('setFileStatus', strings.uploadStatus.waiting)

        const errorResponse = error.response
        if (errorResponse) {
          let errors = errorResponse.data.error.errors[0]

          const errorReason = errorResponse.data.error.message.code
          const errorStatus = errorResponse.status

          if (errorStatus === 422) {
            switch (errorReason) {
              case 'employeegroupfilewithinvalidrows':
                dispatch('setFileStatus', strings.uploadStatus.error)
                dispatch('setFileId', errors.message)
                break
            }
          }
        }
      }
    },
    async getFileErrors({ state }) {
      let response = await employeeGroupsService.getEmployeeGroupsFileErrors(state.fileId)
      let contentType = response.headers['content-type']
      let blob = new Blob([response.data], { type: contentType })
      utils.handleDownload(blob, 'file-errors.xlsx')
    },
    setGroupId({ commit }, groupId) {
      commit(EMPLOYEE_GROUPS.SET_GROUP_ID, groupId)
    },
    setGroupName({ commit }, groupName) {
      commit(EMPLOYEE_GROUPS.SET_GROUP_NAME, groupName)
    },
    setImportCode({ commit }, importCode) {
      commit(EMPLOYEE_GROUPS.SET_GROUP_IMPORTCODE, importCode)
    },
    setTeamManagers({ commit }, teamManagers) {
      commit(EMPLOYEE_GROUPS.SET_GROUP_TEAM_MANAGERS, teamManagers)
    },
    setDeskGroups({ commit }, deskGroups) {
      commit(EMPLOYEE_GROUPS.SET_GROUP_DESKGROUPS, deskGroups)
    },
    setCharteredBuses({ commit }, charteredBuses) {
      commit(EMPLOYEE_GROUPS.SET_GROUP_CHARTEREDBUSES, charteredBuses)
    },
    setParkings({ commit }, parkings) {
      commit(EMPLOYEE_GROUPS.SET_GROUP_PARKINGS, parkings)
    },
    setLockers({ commit }, lockers) {
      commit(EMPLOYEE_GROUPS.SET_GROUP_LOCKERS, lockers)
    },
    setRooms({ commit }, rooms) {
      commit(EMPLOYEE_GROUPS.SET_GROUP_ROOMS, rooms)
    },
    setGroupEmployees({ commit }, users) {
      commit(EMPLOYEE_GROUPS.SET_GROUP_EMPLOYEES, users)
    },
    addGroupEmployees({ commit }, users) {
      commit(EMPLOYEE_GROUPS.ADD_GROUP_EMPLOYEES, users)
    },
    setAvailableDeskGroups({ commit }, availableGroups) {
      commit(EMPLOYEE_GROUPS.SET_AVAILABLE_GROUPS, availableGroups)
    },
    setAvailableCharteredBuses({ commit }, availableCharteredBuses) {
      commit(EMPLOYEE_GROUPS.SET_AVAILABLE_CHARTERED_BUSES, availableCharteredBuses)
    },
    setAvailableParkings({ commit }, availableParkings) {
      commit(EMPLOYEE_GROUPS.SET_AVAILABLE_PARKINGS, availableParkings)
    },
    setAvailableLockers({ commit }, availableLockers) {
      commit(EMPLOYEE_GROUPS.SET_AVAILABLE_LOCKERS, availableLockers)
    },
    setAvailableRooms({ commit }, availableRooms) {
      commit(EMPLOYEE_GROUPS.SET_AVAILABLE_ROOMS, availableRooms)
    },
    setFileStatus({ commit }, status) {
      commit(EMPLOYEE_GROUPS.SET_FILE_STATUS, status)
    },
    setFileId({ commit }, fileId) {
      commit(EMPLOYEE_GROUPS.SET_FILE_ID, fileId)
    },
    selectTeamManager({ commit }, item) {
      let manager = item.email ? { email: item.email, name: item.name } : { email: item }
      commit(EMPLOYEE_GROUPS.SELECT_TEAM_MANAGER, manager)
    },
    removeTeamManager({ commit }, index) {
      commit(EMPLOYEE_GROUPS.REMOVE_TEAM_MANAGER, index)
    },
    setIsDownloadingFile({ commit }, value) {
      commit(EMPLOYEE_GROUPS.SET_IS_DOWNLOADING_FILE, value)
    },
    resetGroup({ dispatch, commit }) {
      dispatch('setGroupId', null)
      dispatch('setGroupName', '')
      dispatch('setImportCode', '')
      dispatch('setTeamManagers', [])
      dispatch('setDeskGroups', [])
      dispatch('setGroupEmployees', [])
      dispatch('setCharteredBuses', [])
      dispatch('setParkings', [])
      dispatch('setAvailableDeskGroups', [])
      dispatch('setAvailableCharteredBuses', [])
      dispatch('setAvailableParkings', [])
      dispatch('setAvailableLockers', [])
      dispatch('setAvailableRooms', [])
      dispatch('setRemoveList', [])
      dispatch('setEmployees', [])
      commit(EMPLOYEE_GROUPS.SET_LOADING_STATUS, 'STATUS_INITIAL')
    },
    selectGroup({ commit }, id) {
      commit(EMPLOYEE_GROUPS.SELECT_GROUP, id)
    },
    selectAllGroups({ commit, getters }) {
      commit(EMPLOYEE_GROUPS.SELECT_ALL_GROUP, getters.selectedAll)
    },
    setWaitingSlotsLoadingStatus: function ({ commit }) {
      commit(EMPLOYEE_GROUPS.SET_LOADING_STATUS, 'STATUS_WAITING')
    },
    setRemoveList: function ({ commit }, removeList) {
      commit(EMPLOYEE_GROUPS.SET_REMOVE_LIST, removeList)
    },
    setEmployees: function ({ commit }, employees) {
      commit(EMPLOYEE_GROUPS.SET_EMPLOYEES, employees)
    },
    removeFromEmployeesGroup: function ({ commit }, employee) {
      commit(EMPLOYEE_GROUPS.REMOVE_FROM_EMPLOYEE_GROUP, employee)
    },
  }
}
